jQuery(function () {
  $('.nav-opener').click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $('html').toggleClass('nav-active');
  });
  initMobileNav();
  $(window).resize(function () {
    initMobileNav();
  });
  $(document).click(function (e) {
    $target = $(e.target);
    console.log($target);

    if ($target.is('a.login-btn')) {
      e.preventDefault();

      if ($('.header__login-list').hasClass('active-menu')) {
        $('.header__login-list').removeClass('active-menu');
      } else {
        $('.header__login-list').addClass('active-menu');
      }
    } else {
      $('.header__login-list').removeClass('active-menu');
    }
  });
}); // mobile menu init

function initMobileNav() {
  $('.navbar__nav > li > .sub-menu li:has(ul)').addClass('parent-menu-item ');
  $('.navbar__nav > li > .sub-menu > li:has(ul) > a').addClass('icon-menu-arrow ');

  if ($(window).width() <= 1024) {
    $('.menu-item-has-children').each(function () {
      $(this).append($('<span class="back"></span>'));
    });
    $('.icon-menu-arrow').click(function (e) {
      $('.icon-menu-arrow').siblings('.sub-menu').removeClass('active');
      var $subMenu = $(this).siblings('.sub-menu');

      if ($subMenu.hasClass('active')) {
        $subMenu.removeClass('active');
        $subMenu.closest('.parent-menu-item').removeClass('active');
        $subMenu.closest('.parent-menu-item').closest('.sub-menu').removeClass('sub-active');
      } else {
        $subMenu.addClass('active');
        $subMenu.closest('.parent-menu-item').addClass('active');
        $subMenu.closest('.parent-menu-item').closest('.sub-menu').addClass('sub-active');
      }
    });
    $('.parent-menu-item > a').click(function (e) {
      if ($(window).width() <= 1024) {
        e.preventDefault();
        $(this).siblings('.sub-menu').addClass('active');
      }
    });
    $('.back').click(function (e) {
      $(this).siblings('.sub-active').find('.menu-item-has-children.active-item').removeClass('active-item');
      e.stopPropagation();

      if ($('.parent-menu-item.active').length == 1) {
        $(this).siblings('.sub-active').find('.sub-menu.active').removeClass('active');
        $(this).siblings('.sub-active').find('.parent-menu-item.active').removeClass('active');
        $(this).siblings('.sub-active').removeClass('sub-active');
        $('.menu-item').removeClass('disabled');
      } else {
        $(this).parent().removeClass('active-item');
      }

      $('.menu-item-has-children').addClass('disabled');
    });
  }

  var iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
  var event = "click";
  if (iOS != null) event = "touchstart";
  $(function () {
    $(document).on(event, ".menu-item-has-children > a", function (e) {
      if ($(window).width() <= 1024) {
        e.preventDefault();

        if ($(this).parent().hasClass('active-item')) {
          $(this).parent().removeClass('active-item');
          $(this).parent().removeClass('disabled');
          $(this).parent().siblings().removeClass('disabled');
        } else {
          $(this).parent().addClass('active-item');
          $(this).parent().siblings().removeClass('active-item');
          $(this).parent().siblings().addClass('disabled');
        }
      }
    });
  });
  $(function () {
    $(document).on(event, ".active-item > a", function (e) {
      $(this).parent().addClass('active-item');
      var href = $(this).attr('href');
      $(location).attr('href', href);
    });
  });
}